module.exports = __webpack_public_path__ + "media/images/top-banner@2x-bae3aaa104099fc1eda0d83ff8e97c38.jpg";